import { Route } from '@angular/router';
import { authGuard } from '../core/guards/auth.guard';

export const appRoutes: Array<Route> = [
  // Must precede the empty-path parent routes below: an empty-path parent
  // matches '' first and renders an empty outlet, so this redirect would never
  // be reached if placed last.
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('../features/login/login.component').then(
            (m) => m.LoginComponent,
          ),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('../features/register/register.component').then(
            (m) => m.RegisterComponent,
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('../features/login/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
      },
      {
        path: 'set-password',
        loadComponent: () =>
          import('../features/set-password/set-password.component').then(
            (m) => m.SetPasswordComponent,
          ),
      },
      {
        path: 'set-password-success',
        loadComponent: () =>
          import('../features/set-password/set-password-success/set-password-success.component').then(
            (m) => m.SetPasswordSuccessComponent,
          ),
      },
      {
        path: 'reset-password-success',
        loadComponent: () =>
          import('../features/login/reset-password-success/reset-password-success.component').then(
            (m) => m.ResetPasswordSuccessComponent,
          ),
      },
      {
        path: 'register-success',
        loadComponent: () =>
          import('../features/register/register-success/register-success.component').then(
            (m) => m.RegisterSuccessComponent,
          ),
      },
      {
        path: 'validation-success',
        loadComponent: () =>
          import('../features/validation-success/validation-success.component').then(
            (m) => m.ValidationSuccessComponent,
          ),
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard],
    data: { requiresAuth: true },
    children: [
      {
        path: 'licenses',
        loadComponent: () =>
          import('../features/licenses/licenses.component').then(
            (m) => m.LicensesComponent,
          ),
      },
      {
        path: 'institution-invitation/done',
        loadComponent: () =>
          import('../features/institution-invitation/success/institution-invitation-success.component').then(
            (m) => m.InstitutionInvitationSuccessComponent,
          ),
      },
    ],
  },
  {
    path: 'login/callback',
    loadComponent: () =>
      import('../features/login/callback/login-callback.component').then(
        (m) => m.LoginCallbackComponent,
      ),
  },
  {
    path: 'login/error',
    loadComponent: () =>
      import('../features/login/error/login-error.component').then(
        (m) => m.LoginErrorComponent,
      ),
  },
  {
    path: 'institution-invitation/error',
    loadComponent: () =>
      import('../features/institution-invitation/error/institution-invitation-error.component').then(
        (m) => m.InstitutionInvitationErrorComponent,
      ),
  },
  {
    path: 'silent-callback',
    loadComponent: () =>
      import('../features/silent-callback/silent-callback.component').then(
        (m) => m.SilentCallbackComponent,
      ),
  },
  {
    path: 'institutions/invitations',
    loadComponent: () =>
      import('../features/institution-invitation/redirect/institution-invitation-redirect.component').then(
        (m) => m.InstitutionInvitationRedirectComponent,
      ),
  },
];
